module.exports = __webpack_public_path__ + "static/media/select-dropdown-filled.f960e405.svg";